var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusReady(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0036 8.0877V19.0032C21.0036 20.1083 20.1078 21.0041 19.0028 21.0041H4.99693C3.8919 21.0041 2.9961 20.1083 2.9961 19.0032V8.0877C2.99572 7.81639 3.05052 7.54784 3.15716 7.29837L4.47771 4.20809C4.79346 3.47263 5.51711 2.9961 6.31748 2.99658H17.6822C18.4833 2.99658 19.2072 3.47446 19.522 4.21109L20.8425 7.29837C20.949 7.54789 21.0038 7.81641 21.0036 8.0877Z",
    stroke: "#00B26B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99609 7.99826H20.9936",
    stroke: "#00B26B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0011 2.99658L15.0015 7.99867V11.225C14.9768 11.6761 14.5924 12.0225 14.1412 12.0003H9.85938C9.40818 12.0225 9.02379 11.6761 8.99902 11.225V7.99867L9.99944 2.99658",
    stroke: "#00B26B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99805 18.0026H7.99888",
    stroke: "#00B26B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusReady);
export default __webpack_public_path__ + "static/media/status-ready.cc70815632a3ffcab6b1fb105fe42fc5.svg";
export { ForwardRef as ReactComponent };